// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.league-match-result__contianer__info-teams {
    display: flex;
    align-items: center;    
    padding: 32px 160px;
}

.league-match-result__container__teams {
    width: 100%;
}

.league-match-result__container__teams img {
    width: 90px;
    height: 90px;
    border-radius: 50%;
}

.league-match-result__cointainer__team-resume {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.league-match-result__cointainer__team-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.league-match-result__cointainer__team-container .icon-ball {
    color: var( --white-color );
    font-size: calc( var( --space-x3 ) + var( --space-quarter ) );
    border-radius: 50%;
    padding: calc( var( --space-half ) + var( --space-eighth ) ); 
}

.league-match-result__cointainer__team-container .baloa-headline-2 {
    color: var( --primary-dark-color );
    margin: calc( var( --space-and-half ) + var( --space-eighth ) ) 0 var( --space-half-quarter ) 0;
}

.league-match-result__cointainer__team-container .baloa-normal-text {
    color: var( --basic-gray-color );
}

.league-match-result__score .baloa-headline-2 {
    color: var( --primary-dark-color );
    font-size: calc( var( --space-x3 ) + var( --space-half ) + 1px);
}

.league-match-result__score.left .baloa-headline-2:first-of-type {
    margin-right: var( --space-x3 );
}

.league-match-result__score.right .baloa-headline-2:first-of-type {
    margin-left: var( --space-x3 );
}

.league-match-result__score .baloa-headline-1 {
    font-weight: var(--font-regular);
    color: var( --primary-very-dark-color );
    text-align: center;
    margin-top: var( --space );
}

.league-match-result__score.left .baloa-headline-1:last-of-type {
    margin-right: var( --space-half );
    text-align: right;
}

.league-match-result__score.right .baloa-headline-1:last-of-type {
    margin-left: var( --space-half );
    text-align: left;
}

.league-match-result__separator-line {
    border: 1px solid var(--new-gray-background-color);
    height: 0px;
    width: 98%;
    margin: 0 auto;
}

.league-match-result__match-info {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    padding: var(--space) 0;
}

.league-match-result__match-info__item {
    display: flex;
    align-items: center;
}

.league-match-result {
    background-color: var(--white-color);
    margin-bottom: var(--space-half-quarter);
    border-radius: var(--space-half);
}

.league-match-result__match-info__item div.baloa-table-column {
    margin-left: var(--space-half-quarter);
}

.league-match-result__match-info__item span {
    font-size: calc( var(--space) + var(--space-quarter) );
}

.league-match-result__match-info__item .baloa-table-column {
    color: var(--basic-gray-color);
}

.league-match-result__cointainer__team-resume.visitant {
    justify-content: flex-end;
}

.baloa-headline-2.league-match-result__score{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.league-match-result__score__referees-assignment.button {
    padding: var(--space-half-quarter);
    white-space: nowrap;
    margin-top: var(--space-x2);
    text-transform: none;
}

.league-match-result__score__referees-assignment.center-button{
    margin: 0 auto;
    top: -60px;
    position: relative;
}

.league-match-result__cointainer__team-resume.local {
    justify-content: flex-start;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .league-match-result{
        background: none;
    }

    .league-match-result__contianer__info-teams {
        padding: 20px 16px;
        background:var(--white-color);       
    }

    .league-match-result__cointainer__team-container .icon-ball {
        font-size: 28px;
        padding: 5px;
    }

    .league-match-result__match-info{
        margin: 0;
        background: var(--white-color);
        flex-direction: column;
        display: block;
        padding: var(--space) var(--space) 0 var(--space);
        border-radius: 4px;
    }

    .league-match-result__match-info__item {
        padding-bottom: var(--space);
    }

    .league-match-result__match-info__item .baloa-table-column {
        color: var(--primary-dark-color);
    }

    .league-match-result__container__teams img {
        width: 38px;
        height: 38px;
        border-radius: 50%;
    }

    .league-match-result__cointainer__team-container .baloa-headline-2 {
        white-space: nowrap;
        margin: 8px 0;
    }

    .league-match-result__score.left .baloa-headline-2:first-of-type, 
    .league-match-result__score.right .baloa-headline-2:first-of-type{
        margin-right:var(--space);
        margin-left: var(--space);
        font-size:var(--space-x2);
    }

    .league-match-result__score.left .baloa-headline-1:last-of-type,
     .league-match-result__score.right .baloa-headline-1:last-of-type{
        margin-right:var(--space-half);
        margin-left: var(--space-half);
        margin-top: var( --space-half);
        font-size: var(--space-and-half);/*24px*/
        font-weight: var(--font-medium);
    }

    .league-match-result__score .baloa-headline-1{
        margin-top: var( --space-half);/*12px*/
    }

    .league-match-result__score .baloa-headline-2{
        margin-right:0;
        font-size:21px
    }

    .league-match-result__cointainer__team-container {
        align-items: center;
    }

    .league-match-result__cointainer__team-container .baloa-table {
        color: var( --primary-very-dark-color );
    }

    .league-match-result__cointainer__team-resume {
        justify-content: center;
    }

    .league-match-result__score-score{
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 4px;
    }

    .league-match-result__score-state{
        background: var(--basic-gray-color);
        border-radius: 2px;
        padding: 2px 4px;
        margin-top: 8px;
    }

    .league-match-result__score-state.baloa-username{
        color: var(--white-color);
    }
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-match-result-component/LeagueMatchResultComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,6DAA6D;IAC7D,kBAAkB;IAClB,4DAA4D;AAChE;;AAEA;IACI,kCAAkC;IAClC,+FAA+F;AACnG;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,+DAA+D;AACnE;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;IAChC,uCAAuC;IACvC,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,iCAAiC;IACjC,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,kDAAkD;IAClD,WAAW;IACX,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,wCAAwC;IACxC,gCAAgC;AACpC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,SAAS;QACT,8BAA8B;QAC9B,sBAAsB;QACtB,cAAc;QACd,iDAAiD;QACjD,kBAAkB;IACtB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,aAAa;IACjB;;IAEA;;QAEI,yBAAyB;QACzB,yBAAyB;QACzB,yBAAyB;IAC7B;;IAEA;;QAEI,8BAA8B;QAC9B,8BAA8B;QAC9B,8BAA8B;QAC9B,gCAAgC,CAAC,OAAO;QACxC,+BAA+B;IACnC;;IAEA;QACI,8BAA8B,CAAC,OAAO;IAC1C;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,QAAQ;IACZ;;IAEA;QACI,mCAAmC;QACnC,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":[".league-match-result__contianer__info-teams {\n    display: flex;\n    align-items: center;    \n    padding: 32px 160px;\n}\n\n.league-match-result__container__teams {\n    width: 100%;\n}\n\n.league-match-result__container__teams img {\n    width: 90px;\n    height: 90px;\n    border-radius: 50%;\n}\n\n.league-match-result__cointainer__team-resume {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.league-match-result__cointainer__team-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.league-match-result__cointainer__team-container .icon-ball {\n    color: var( --white-color );\n    font-size: calc( var( --space-x3 ) + var( --space-quarter ) );\n    border-radius: 50%;\n    padding: calc( var( --space-half ) + var( --space-eighth ) ); \n}\n\n.league-match-result__cointainer__team-container .baloa-headline-2 {\n    color: var( --primary-dark-color );\n    margin: calc( var( --space-and-half ) + var( --space-eighth ) ) 0 var( --space-half-quarter ) 0;\n}\n\n.league-match-result__cointainer__team-container .baloa-normal-text {\n    color: var( --basic-gray-color );\n}\n\n.league-match-result__score .baloa-headline-2 {\n    color: var( --primary-dark-color );\n    font-size: calc( var( --space-x3 ) + var( --space-half ) + 1px);\n}\n\n.league-match-result__score.left .baloa-headline-2:first-of-type {\n    margin-right: var( --space-x3 );\n}\n\n.league-match-result__score.right .baloa-headline-2:first-of-type {\n    margin-left: var( --space-x3 );\n}\n\n.league-match-result__score .baloa-headline-1 {\n    font-weight: var(--font-regular);\n    color: var( --primary-very-dark-color );\n    text-align: center;\n    margin-top: var( --space );\n}\n\n.league-match-result__score.left .baloa-headline-1:last-of-type {\n    margin-right: var( --space-half );\n    text-align: right;\n}\n\n.league-match-result__score.right .baloa-headline-1:last-of-type {\n    margin-left: var( --space-half );\n    text-align: left;\n}\n\n.league-match-result__separator-line {\n    border: 1px solid var(--new-gray-background-color);\n    height: 0px;\n    width: 98%;\n    margin: 0 auto;\n}\n\n.league-match-result__match-info {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    padding: var(--space) 0;\n}\n\n.league-match-result__match-info__item {\n    display: flex;\n    align-items: center;\n}\n\n.league-match-result {\n    background-color: var(--white-color);\n    margin-bottom: var(--space-half-quarter);\n    border-radius: var(--space-half);\n}\n\n.league-match-result__match-info__item div.baloa-table-column {\n    margin-left: var(--space-half-quarter);\n}\n\n.league-match-result__match-info__item span {\n    font-size: calc( var(--space) + var(--space-quarter) );\n}\n\n.league-match-result__match-info__item .baloa-table-column {\n    color: var(--basic-gray-color);\n}\n\n.league-match-result__cointainer__team-resume.visitant {\n    justify-content: flex-end;\n}\n\n.baloa-headline-2.league-match-result__score{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.league-match-result__score__referees-assignment.button {\n    padding: var(--space-half-quarter);\n    white-space: nowrap;\n    margin-top: var(--space-x2);\n    text-transform: none;\n}\n\n.league-match-result__score__referees-assignment.center-button{\n    margin: 0 auto;\n    top: -60px;\n    position: relative;\n}\n\n.league-match-result__cointainer__team-resume.local {\n    justify-content: flex-start;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .league-match-result{\n        background: none;\n    }\n\n    .league-match-result__contianer__info-teams {\n        padding: 20px 16px;\n        background:var(--white-color);       \n    }\n\n    .league-match-result__cointainer__team-container .icon-ball {\n        font-size: 28px;\n        padding: 5px;\n    }\n\n    .league-match-result__match-info{\n        margin: 0;\n        background: var(--white-color);\n        flex-direction: column;\n        display: block;\n        padding: var(--space) var(--space) 0 var(--space);\n        border-radius: 4px;\n    }\n\n    .league-match-result__match-info__item {\n        padding-bottom: var(--space);\n    }\n\n    .league-match-result__match-info__item .baloa-table-column {\n        color: var(--primary-dark-color);\n    }\n\n    .league-match-result__container__teams img {\n        width: 38px;\n        height: 38px;\n        border-radius: 50%;\n    }\n\n    .league-match-result__cointainer__team-container .baloa-headline-2 {\n        white-space: nowrap;\n        margin: 8px 0;\n    }\n\n    .league-match-result__score.left .baloa-headline-2:first-of-type, \n    .league-match-result__score.right .baloa-headline-2:first-of-type{\n        margin-right:var(--space);\n        margin-left: var(--space);\n        font-size:var(--space-x2);\n    }\n\n    .league-match-result__score.left .baloa-headline-1:last-of-type,\n     .league-match-result__score.right .baloa-headline-1:last-of-type{\n        margin-right:var(--space-half);\n        margin-left: var(--space-half);\n        margin-top: var( --space-half);\n        font-size: var(--space-and-half);/*24px*/\n        font-weight: var(--font-medium);\n    }\n\n    .league-match-result__score .baloa-headline-1{\n        margin-top: var( --space-half);/*12px*/\n    }\n\n    .league-match-result__score .baloa-headline-2{\n        margin-right:0;\n        font-size:21px\n    }\n\n    .league-match-result__cointainer__team-container {\n        align-items: center;\n    }\n\n    .league-match-result__cointainer__team-container .baloa-table {\n        color: var( --primary-very-dark-color );\n    }\n\n    .league-match-result__cointainer__team-resume {\n        justify-content: center;\n    }\n\n    .league-match-result__score-score{\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: 4px;\n    }\n\n    .league-match-result__score-state{\n        background: var(--basic-gray-color);\n        border-radius: 2px;\n        padding: 2px 4px;\n        margin-top: 8px;\n    }\n\n    .league-match-result__score-state.baloa-username{\n        color: var(--white-color);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
